import classNames from "classnames";
import React from "react";

export const prefixCls = "ac-comment-editor";

export const ToolBarButton = ({
  children,
  onClick,
  active,
  type,
  disabled,
  className,
  ...restDivProps
}: {
  active?: boolean;
  type?: string;
  disabled?: boolean;
} & React.HTMLAttributes<HTMLDivElement>) => {
  return (
    <div
      className={classNames(
        `${prefixCls}-tool-bar-button`,
        {
          active,
          disabled,
        },
        className,
      )}
      onClick={onClick}
      data-type={type}
      {...restDivProps}
    >
      {children}
    </div>
  );
};
